import {Injectable} from "@angular/core";
import {IService} from "../IService";
import {TouchPointModel} from "../../models/touch-point.model";
import {HttpClientService} from "../httpClient/httpclient.service";

import {Observable} from 'rxjs/Observable';

@Injectable()
export class PromotionTouchPointService extends IService<TouchPointModel> {

  constructor(
    http: HttpClientService
  ) {
    super(http, 'koncentro-promo', 'touch-point');
  }

  get(id) {
    return super.get(id).map(
      (result) => {
        /*conversione*/
        this.parseFromCharToBoolean(result);
        /*ordinamento*/
        result.privacyList.sort((obj1, obj2) => {
          return obj1.row_number - obj2.row_number
        });
        return result
      }
    );
  }

  update(model: TouchPointModel): Observable<TouchPointModel> {
    this.parseFromBooleanToChar(model);
    return super.update(model);
  }

  create(model: TouchPointModel): Observable<TouchPointModel> {
    this.parseFromBooleanToChar(model);
    return super.create(model);
  }

  parseFromCharToBoolean(item: any) {
    if (item.privacyList && item.privacyList.length > 0) {
      for (let elem of item.privacyList) {
        elem.flg_newsletter = elem.flg_newsletter === '1';
        elem.flg_privacy_optin = elem.flg_privacy_optin === '1';
        elem.flg_privacy_purchase_com = elem.flg_privacy_purchase_com === '1';
        elem.flg_privacy_mktg_activitiy = elem.flg_privacy_mktg_activitiy === '1';
        elem.flg_privacy_auth = elem.flg_privacy_auth === '1';
        elem.flg_privacy_mktg_research = elem.flg_privacy_mktg_research === '1';
        elem.flg_privacy_generic_comm = elem.flg_privacy_generic_comm === '1';
        elem.flg_privacy_mktg_profiling = elem.flg_privacy_mktg_profiling === '1';
        elem.flg_privacy_terminal = elem.flg_privacy_terminal === '1';
      }
    }
  }

  parseFromBooleanToChar(item: any) {
    if (item.privacyList && item.privacyList.length > 0) {
      for (let elem of item.privacyList) {
        elem.flg_newsletter = elem.flg_newsletter === true ? '1' : '0';
        elem.flg_privacy_optin = elem.flg_privacy_optin === true ? '1' : '0';
        elem.flg_privacy_purchase_com = elem.flg_privacy_purchase_com === true ? '1' : '0';
        elem.flg_privacy_mktg_activitiy = elem.flg_privacy_mktg_activitiy === true ? '1' : '0';
        elem.flg_privacy_auth = elem.flg_privacy_auth === true ? '1' : '0';
        elem.flg_privacy_mktg_research = elem.flg_privacy_mktg_research === true ? '1' : '0';
        elem.flg_privacy_generic_comm = elem.flg_privacy_generic_comm === true ? '1' : '0';
        elem.flg_privacy_mktg_profiling = elem.flg_privacy_mktg_profiling === true ? '1' : '0';
        elem.flg_privacy_terminal = elem.flg_privacy_terminal === true ? '1' : '0';
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-touch-point.service.ts